import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";
import { useMemo } from "react";

const ACTIVITY_TYPE_BASE = "/ActivityTypes";

const getActivityTypeAPI = () => API.get(`${ACTIVITY_TYPE_BASE}`);

const addActivityTypeAPI = (data) =>
  API.post(`${ACTIVITY_TYPE_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateActivityTypeAPI = (id, data) =>
  API.patch(`${ACTIVITY_TYPE_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const baseService = createApplicationService({
  name: "activityTypes",
  apiFetchFn: getActivityTypeAPI,
  apiAddFn: addActivityTypeAPI,
  apiUpdateFn: updateActivityTypeAPI,
});

const activityTypeReducer = baseService.reducer;
const getActivityType = baseService.getData;
const addActivityType = baseService.addData;
const updateActivityType = baseService.updateData;
const useActivityType = baseService.useData;

const getActiveActivityTypes = async () => {
  const activityTypes = await getActivityType();
  return activityTypes.filter((type) => type.active) || [];
};

const useActiveActivityTypes = () => {
  const { data, loading } = useActivityType();
  const activeActivityTypes = useMemo(
    () => data.filter((type) => type.active),
    [data]
  );
  return { data: activeActivityTypes, loading };
};

export {
  activityTypeReducer,
  getActivityType,
  addActivityType,
  updateActivityType,
  useActivityType,
  getActiveActivityTypes,
  useActiveActivityTypes,
};
